/* eslint-disable no-console */
import { getCookie } from 'cookies-next';

const getWebviewAnalyticsId = (device: string): string => {
  const raw = getCookie('webview_analytics_id');
  const distinctId = Array.isArray(raw) ? raw[0] : raw;
  const normalized = typeof distinctId === 'string' ? distinctId.trim() : '';
  if (normalized && normalized !== 'null' && normalized !== 'undefined') {
    return normalized;
  }
  console.error(
    `[WEBVIEW][${device}][DISCOVERY-NEXT] No webview_analytics_id cookie found`
  );
  return '';
};
export { getWebviewAnalyticsId };
